module.exports = __webpack_public_path__ + "img/clock.0b73f028.svg";